import React, { useEffect, useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useMediaQuery } from 'react-responsive'

const CropperModal = (props) => {
  const { image, show, onHide, setCroppedImage } = props;
  const canvasRef = useRef(null);
  const [scale, setScale] = useState(1);
  const [initialPinchDistance, setInitialPinchDistance] = useState(null); // Added this line
  const [lastTouch, setLastTouch] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState({
    x: 0,
    y: 0,
  });
  useEffect(() => {
    const handleTouchStart = (event) => {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    };

    document.body.classList.add('disable-touch-zoom');
    document.addEventListener('touchstart', handleTouchStart, { passive: false });

    return () => {
      document.body.classList.remove('disable-touch-zoom');
      document.removeEventListener('touchstart', handleTouchStart);
    };
  }, []);
  useEffect(() => {
    if (image) {
      handleCanvasDraw();
    }
  }, [image, scale, position]);
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
  const handleCanvasDraw = () => {
    const canvas = canvasRef.current;
    if (canvas && image) {
      const context = canvas.getContext("2d");
      if (context) {
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(
          image,
          position.x,
          position.y,
          image.width * scale,
          image.height * scale
        );
      }
    }
  };

  const handleMouseDown = (e) => {
    e.preventDefault();
    //  console.log("dowwnn")
    const canvas = canvasRef.current;
    if (canvas) {
      const rect = canvas.getBoundingClientRect();
      const mouseX = e.clientX - rect.left;
      const mouseY = e.clientY - rect.top;

      const offsetX = mouseX - position.x;
      const offsetY = mouseY - position.y;

      const onMouseMove = (e) => {
        e.preventDefault();
        setPosition({
          x: e.clientX - rect.left - offsetX,
          y: e.clientY - rect.top - offsetY,
        });
      };

      const onMouseUp = () => {
        window.removeEventListener("mousemove", onMouseMove);
        window.removeEventListener("mouseup", onMouseUp);
      };

      window.addEventListener("mousemove", onMouseMove);
      window.addEventListener("mouseup", onMouseUp);
    }
  };
  const handleTouchStart = (e) => {
    e.preventDefault();
    const touch = e.touches[0];
    setLastTouch({ x: touch.clientX, y: touch.clientY });

    if (e.touches.length === 1) {
      setIsDragging(true);
    }

    if (e.touches.length === 2) {
      const touch1 = e.touches[0];
      const touch2 = e.touches[1];
      const distance = Math.sqrt(
        (touch1.clientX - touch2.clientX) ** 2 +
          (touch1.clientY - touch2.clientY) ** 2
      );
      setInitialPinchDistance(distance);
    }
  };
  const handleTouchMove = (e) => {
    e.preventDefault();

    if (e.touches.length === 1 && isDragging && lastTouch) {
      const touch = e.touches[0];
      const deltaX = touch.clientX - lastTouch.x;
      const deltaY = touch.clientY - lastTouch.y;
      setLastTouch({ x: touch.clientX, y: touch.clientY });

      setPosition((prevPosition) => ({
        x: prevPosition.x + deltaX / scale,
        y: prevPosition.y + deltaY / scale,
      }));
    }
    if (e.touches.length === 2 && initialPinchDistance !== null) {
      const touch1 = e.touches[0];
      const touch2 = e.touches[1];
      const distance = Math.sqrt(
        (touch1.clientX - touch2.clientX) ** 2 +
          (touch1.clientY - touch2.clientY) ** 2
      );
      const delta = (distance - initialPinchDistance) * 0.01;
      setScale((prevScale) => Math.max(0.1, prevScale + delta));
    }
  };
  const handleTouchEnd = () => {
    setLastTouch(null);
    setInitialPinchDistance(null);
    setIsDragging(false);
  };
  const handleWheel = (e) => {
    // e.preventDefault();
    const scaleIncrement = 0.1;
    const delta = e.deltaY < 0 ? 1 : -1;
    const newScale = scale + delta * scaleIncrement;
    setScale(Math.max(0.1, newScale));
  };

  const handleCrop = () => {
    onHide();
    const canvas = canvasRef.current;
    if (canvas) {
      const croppedCanvas = document.createElement("canvas");
      const ctx = croppedCanvas.getContext("2d");
      if (ctx) {
        //  console.log("handleCrop", canvas);
        croppedCanvas.width = canvas.width;
        croppedCanvas.height = canvas.height;
        ctx.clearRect(0, 0, croppedCanvas.width, croppedCanvas.height);
        ctx.globalCompositeOperation = "destination-over";
        ctx.drawImage(canvas, 0, 0);
        setCroppedImage(croppedCanvas.toDataURL("image/png"));
      }
    }
  };

  const handleZoomIn = (e) => {
    e.preventDefault();
    const scaleIncrement = 0.05; // Adjust this value for finer or coarser zooming
  const newScale = scale * (1 + scaleIncrement);
  setScale(Math.min(newScale, 2)); // Limit the maximum scale
    // setScale((prevScale) => Math.min(prevScale + 0.1, 2));
  };
  const handleZoomIn5x = (e) => {
    e.preventDefault();
    const scaleIncrement = .2; // Adjust this value for finer or coarser zooming
  const newScale = scale * (1 + scaleIncrement);
  setScale(Math.min(newScale, 2)); // Limit the maximum scale
    // setScale((prevScale) => Math.min(prevScale + 0.1, 2));
  };

  const handleZoomOut = (e) => {
    e.preventDefault();
    const scaleIncrement = 0.05; // Adjust this value for finer or coarser zooming
  const newScale = scale * (1 - scaleIncrement);
  setScale(Math.max(newScale, 0.1)); // Limit the minimum scale
    // setScale((prevScale) => Math.max(prevScale - 0.1, 0.1));
  };
  const handleZoomOut5x = (e) => {
    e.preventDefault();
    const scaleIncrement = 0.2; // Adjust this value for finer or coarser zooming
  const newScale = scale * (1 - scaleIncrement);
  setScale(Math.max(newScale, 0.1)); // Limit the minimum scale
    // setScale((prevScale) => Math.max(prevScale - 0.1, 0.1));
  };

  return (
    <div>
      <div
        className={`modal ${show && "show"}`}
        id="exampleModalCenter"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered cropmodal" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Cropper
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={onHide}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div
              className="modal-body"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "gray",
                // width:"90%"
              }}
            >
              
              {isTabletOrMobile ?
              <canvas
                ref={canvasRef}
              //  width={400}
              //   height={400}
                
               width={200}
                height={200}
                style={{ cursor: "grab", background: "white" , touchAction: "none !important" }}
                onMouseDown={handleMouseDown}
                onWheel={handleWheel}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
              ></canvas>:
              <canvas
                ref={canvasRef}
               width={400}
                height={400}
                
              //  width="100%"
              //   height="100%"
                style={{ cursor: "grab", background: "white" }}
                onMouseDown={handleMouseDown}
                onWheel={handleWheel}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
              ></canvas>}
            </div>
            <div
              className="modal-footer"
              style={{
                display: "flex",
                justifyContent: "space-between roundbtns",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                }}
              >
                <button
                  type="button"
                  className="btn btn-primary roundbtns"
                  onClick={handleZoomIn}
                >
                  +
                </button>
               
                <Button
                  type="button"
                  className="btn btn-primary roundbtns "
                  onClick={handleZoomOut}
                  // style={{ maxHeight:".5rem"}}
                >
                  -
                </Button>
                <button
                  type="button"
                  className="btn btn-primary roundbtns"
                  onClick={handleZoomIn5x}
                >
                  + (5x)
                </button>
                <Button
                  type="button"
                  className="btn btn-primary roundbtns"
                  onClick={handleZoomOut5x}
                >
                  - (5x)
                </Button>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                }}
              >
                <button
                  type="button"
                  className="btn btn-primary roundbtns"
                  onClick={handleCrop}
                >
                  Save Image
                </button>
                <button
                  type="button"
                  className="btn btn-secondary roundbtns"
                  onClick={onHide}
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{
        marginTop:"100px"
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Crop Image
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{
        display:"flex",
        justifyContent:"center",
        alignItems:"center",
        background:"gray"
      }}>
        <canvas
          ref={canvasRef}
          width={400}
          height={400}
          style={{ cursor: "grab" ,background: "white" }}
          onMouseDown={handleMouseDown}
          onWheel={handleWheel}
        ></canvas>
      </Modal.Body>
      <Modal.Footer style={{
        display:"flex",
        justifyContent:"space-between",
      }}>
        <div style={{
          display:"flex",
          gap:"5px"
        }}>
          <Button onClick={handleZoomIn}>+</Button>
          <Button onClick={handleZoomOut}>-</Button>
        </div>
        <div style={{
          display:"flex",
          gap:"5px"
        }}>
          <Button >Crop Image</Button>
          <Button  variant="secondary">
            Close
          </Button>
        </div>
      </Modal.Footer>
    </Modal> */}
    </div>
  );
};

export default CropperModal;
